import { DrawerDetailsInjectedProps } from 'components/drawerDetailsWrapper/types';
import LoadingSpinner from 'design-component/loadingSpinner';
import React, { FC } from 'react';

export const FakeLoadingEntity: FC<DrawerDetailsInjectedProps> = () => <LoadingSpinner position="absolute" />;
